import React from 'react'
import ClousureInfoApplDetails from './ClousureInfoApplDetails'

export default function CloserOfInstitution() {
    return (
        <div><ClousureInfoApplDetails/></div>
    )
}
